/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionGroupSchema } from './ConditionGroupSchema';
import {
    ConditionGroupSchemaFromJSON,
    ConditionGroupSchemaFromJSONTyped,
    ConditionGroupSchemaToJSON,
    ConditionGroupSchemaToJSONTyped,
} from './ConditionGroupSchema';

/**
 * The stored condition after a tree write, plus any reason it cannot fire.
 * @export
 * @interface ConditionTreeResponse
 */
export interface ConditionTreeResponse {
    /**
     * 
     * @type {string}
     * @memberof ConditionTreeResponse
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionTreeResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionTreeResponse
     */
    readonly summary: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionTreeResponse
     */
    readonly isUsable: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionTreeResponse
     */
    readonly problems: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConditionTreeResponse
     */
    readonly version: string;
    /**
     * 
     * @type {Array<ConditionGroupSchema>}
     * @memberof ConditionTreeResponse
     */
    readonly groups: Array<ConditionGroupSchema>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionTreeResponse
     */
    warnings: Array<string>;
}

/**
 * Check if a given object implements the ConditionTreeResponse interface.
 */
export function instanceOfConditionTreeResponse(value: object): value is ConditionTreeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if ((!('isUsable' in (value as Record<string, any>)) && !('is_usable' in (value as Record<string, any>))) || ((value as Record<string, any>)['isUsable'] === undefined && (value as Record<string, any>)['is_usable'] === undefined)) return false;
    if (!('problems' in value) || value['problems'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    return true;
}

export function ConditionTreeResponseFromJSON(json: any): ConditionTreeResponse {
    return ConditionTreeResponseFromJSONTyped(json, false);
}

export function ConditionTreeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionTreeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'summary': json['summary'],
        'isUsable': json['is_usable'],
        'problems': json['problems'],
        'version': json['version'],
        'groups': ((json['groups'] as Array<any>).map(ConditionGroupSchemaFromJSON)),
        'warnings': json['warnings'],
    };
}

export function ConditionTreeResponseToJSON(json: any): ConditionTreeResponse {
    return ConditionTreeResponseToJSONTyped(json, false);
}

export function ConditionTreeResponseToJSONTyped(value?: Omit<ConditionTreeResponse, 'id'|'summary'|'isUsable'|'problems'|'version'|'groups'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'warnings': value['warnings'],
    };
}

